import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import Typography from "@components/typography";
import Fields from "@components/fields";
import Button from "@components/button";
import { Order } from "@apis/index";
import { toast } from "react-toastify";

interface OrderProcessingModalProps {
  orderId: number | string;
  hideModal: () => void;
  onSuccess?: (newStatus: string) => void;
}

const OrderProcessingModal: React.FC<OrderProcessingModalProps> = ({
  orderId,
  hideModal,
  onSuccess,
}) => {
  return (
    <Formik
      initialValues={{ processingTime: 15 }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await Order.updateStatus(orderId, "Order Processing", {
            processingTime: String(values.processingTime),
          });
          toast.success("Order status updated to Order Processing");
          if (onSuccess) onSuccess("Order Processing");
          hideModal();
        } catch (error: any) {
          console.error(error);
          toast.error(error.message || "Failed to update order status");
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Typography styleText="font-size:18px;font-weight:600;margin-bottom:12px;">
            Set Processing Time
          </Typography>
          <Typography styleText="font-size:14px;color:#666;margin-bottom:20px;">
            Please specify the estimated processing time for this order.
          </Typography>

          <Fields.Input
            name="processingTime"
            label="Processing Time (minutes)"
            type="text"
            placeholder="e.g. 15 min - 30 min"
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              title="Cancel"
              variant="outline"
              type="button"
              onClick={hideModal}
            />
            <Button
              title={isSubmitting ? "Saving..." : "Save & Process"}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default OrderProcessingModal;
